/* ALMAVIENNE: visual cart countdown. Never represents inventory reservation. */
let almCartCountdownDeadline = 0;
class AlmCartCountdown extends HTMLElement {
  connectedCallback() {
    this.timeElement = this.querySelector('[data-alm-cart-countdown-time]');
    this.drawer = this.closest('theme-drawer');
    if (!this.timeElement || !this.drawer) return;
    this.drawerObserver = new MutationObserver(() => this.syncWithDrawer());
    this.drawerObserver.observe(this.drawer, { attributes: true, attributeFilter: ['open'] });
    this.syncWithDrawer();
  }

  disconnectedCallback() {
    this.drawerObserver?.disconnect();
    if (this.intervalId) clearInterval(this.intervalId);
    this.intervalId = null;
  }

  syncWithDrawer() {
    if (!this.drawer.hasAttribute('open')) {
      if (this.intervalId) clearInterval(this.intervalId);
      this.intervalId = null;
      almCartCountdownDeadline = 0;
      this.timeElement.textContent = '10:00';
      return;
    }
    if (!almCartCountdownDeadline) almCartCountdownDeadline = Date.now() + 10 * 60 * 1000;
    this.updateDisplay();
    if (!this.intervalId && Date.now() < almCartCountdownDeadline) {
      this.intervalId = setInterval(() => this.updateDisplay(), 1000);
    }
  }

  updateDisplay() {
    if (!this.timeElement) return;
    const seconds = Math.max(0, Math.ceil((almCartCountdownDeadline - Date.now()) / 1000));
    const minutes = String(Math.floor(seconds / 60)).padStart(2, '0');
    const remainder = String(seconds % 60).padStart(2, '0');
    this.timeElement.textContent = minutes + ':' + remainder;
    if (seconds === 0 && this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
  }
}
if (!customElements.get('alm-cart-countdown')) {
  customElements.define('alm-cart-countdown', AlmCartCountdown);
}
